import { getMediaInfo, getMediaInfoPlay } from "@/services/common";

// 初始化播放器实例
export const initPlayer = (dom: any, timeline?: any) => {
  return new Promise((resolve) => {
    resolve(
      new window.AliyunTimelinePlayer({
        container: dom, // 节点元素
        licenseConfig: { rootDomain: "zxaigc.com", licenseKey: "zPtL9R8wGPumTmq2C434ab2bc0b5341ea8f7703afef6793a8" }, // license配置
        timeline: timeline || {}, // 时间线配置
        // 自定义获取媒体信息的函数
        getMediaInfo: async (mediaId, mediaType) => {
          const videoTypeKey = ["video", "audio"];
          if (videoTypeKey.includes(mediaType)) {
            const res: any = await getMediaInfoPlay(mediaId);
            if (res.data?.code === 0) {
              // 获取播放地址
              const { play_info_list = [{ play_url: "" }] } = res.data?.data || {};
              const [playData] = play_info_list;
              return Promise.resolve(playData.play_url);
            }
            return Promise.reject("获取媒体信息失败");
          } else {
            const res: any = await getMediaInfo(mediaId);
            if (res.data?.code === 0) {
              // 获取播放地址
              const { file_info_list = [{ file_basic_info: { file_url: "" } }] } = res.data?.data || {};
              const [playData] = file_info_list;
              return Promise.resolve(playData.file_basic_info.file_url);
            }
            return Promise.reject("获取媒体信息失败");
          }
        },
      }),
    );
  });
};

// 初始化播放器脚本的函数
export const initPlayerScript = () => {
  const src = "https://g.alicdn.com/thor-server/video-editing-websdk/5.4.4/player.js";
  return new Promise((resolve, reject) => {
    // 检查脚本是否已经存在
    const existingScript = document.querySelector(`script[src="${src}"]`);
    if (existingScript) {
      resolve("ok");
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => {
      resolve("ok");
    };
    script.onerror = () => {
      reject("fail");
    };
    document.head.appendChild(script);
  });
};
